import type { MarketTokenProfile } from './types'

/** Evita sustituir perfiles de API por perfiles offline esenciales en reconexiones breves. */
export function resolveTokenProfileQueryEnabled(params: {
  address?: string
  configured: boolean
  isAvailable: boolean
  offlineProfile: MarketTokenProfile | null
}): boolean {
  if (!params.address) return false
  if (params.configured) {
    if (params.isAvailable) return true
    // Nutrimatic gated off (e.g. non-mainnet instance) — still serve offline essentials.
    return params.offlineProfile != null
  }
  return params.offlineProfile != null
}

export function shouldUseOfflineTokenProfile(configured: boolean): boolean {
  return !configured
}
